var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./videoForType.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ed0e7bda\",\"hasScoped\":false,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./videoForType.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/tv/modules/Content/src/videoForType.vue
// module id = LOYM
// module chunks = 2 3 4 6 7 8 9